import * as Schema from "effect/Schema";

import { InputIcon } from "./input.js";

const Align = Schema.Literal("start", "center", "end");

/**
 * IconWidget — one glyph from the design system's `Icon`. Without a `label`
 * it is decorative (the host marks it `aria-hidden`); with one it is an image
 * with that accessible name. The glyph set is the contract's (`DS_ICONS`),
 * the same names an input's icon takes.
 */
export const IconWidgetContent = Schema.Struct({
  contentType: Schema.Literal("icon"),
  name: InputIcon,
  size: Schema.optional(Schema.Literal("sm", "md", "lg")),
  label: Schema.optional(Schema.String.pipe(Schema.minLength(1))),
  align: Schema.optional(Align),
});
export type IconWidgetContent = Schema.Schema.Type<typeof IconWidgetContent>;
